import { render, staticRenderFns } from "./achievementComparison.vue?vue&type=template&id=1190c182&scoped=true"
import script from "./achievementComparison.vue?vue&type=script&lang=js"
export * from "./achievementComparison.vue?vue&type=script&lang=js"
import style0 from "./achievementComparison.vue?vue&type=style&index=0&id=1190c182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1190c182",
  null
  
)

export default component.exports